import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ScrollableItemModel } from '../models/extended-section-options';

@Injectable({
	providedIn: 'root'
})
export class ScrollableItemsHelperOsService {
	public scrollSections = {};
	public disposableSections = {};
	public changeVisibility = new Subject();
	public changeRendered = new Subject();

	constructor() {
		// 
	}

	/**
	 * Add item in the sections object if not exist.
	 * Check if the section exists, if not, create it.
	 * 
	 * @param section 
	 * @param element 
	 */
	addItem(section: string, element: ScrollableItemModel, atBeginning?: boolean): void {
		if (!(section in this.scrollSections)) {
			const nObj = [];
			nObj[section] = [];

			Object.assign(this.scrollSections, nObj);
		}

		const itemsInSection = this.scrollSections[section].length;
		const exist = this.scrollSections[section].find(item => item.id === element.id);

		// New Element
		if (!exist) {
			if (!atBeginning) {
				this.scrollSections[section].push(element);
			} else {
				this.scrollSections[section].unshift(element);
			}
		} else {
			// Update the reference to the new element
			exist.element = element.element;
		}

		if (itemsInSection < 2) {
			this.renderElement(element.section, element);
		}
	}

	/**
	 * Get a scrollSections Item based on the section and the ID
	 * @param section
	 * @param elementId
	 */
	getScrollableItem(section: string, elementId): any {
		if ((section in this.scrollSections)) {
			return this.scrollSections[section].find(item => item.id === elementId);
		}
		return null;
	}

	/**
	 * Add a disposable item, can be a section, component or anything.
	 * Check if the section exists, if not, create it.
	 *
	 * @param section
	 * @param element
	 */
	addDisposableItem(section: string, element: ScrollableItemModel, atBeginning?: boolean): void {
		if (!(section in this.disposableSections)) {
			const nObj = [];
			nObj[section] = [];

			Object.assign(this.disposableSections, nObj);
		}

		const exist = this.disposableSections[section].find(item => item.id === element.id);

		// New Element
		if (!exist) {
			if (!atBeginning) {
				this.disposableSections[section].push(element);
			} else {
				this.disposableSections[section].unshift(element);
			}
		} else {
			// Update the reference to the new element
			exist.element = element.element;
		}
	}

	/**
	 * Remove Disposable Element if Exists
	 *
	 * @param section
	 * @param element
	 */
	removeDisposableItem(section: string, element: ScrollableItemModel): void {
		if ((section in this.disposableSections)) {
			const itemIndex = this.disposableSections[section].findIndex(item => item.id === element.id);

			if (itemIndex !== -1) {
				this.disposableSections[section].splice(itemIndex, 1);
			}
		}
	}

	/**
	 * Get a Disposable Item based on the section and the ID
	 * @param section
	 * @param elementId
	 */
	getDisposableItem(section: string, elementId): any {
		if ((section in this.disposableSections)) {
			return this.disposableSections[section].find(item => item.id === elementId);
		}
		return null;
	}

	/**
	 * Toggle the visible attr of an item in a section of the scrollSections object
	 * @param section 
	 * @param element 
	 */
	toggleVisible(section: string, element: ScrollableItemModel): void {
		if (section in this.scrollSections) {
			const itemIndex = this.scrollSections[section]
				.map((itm) => itm.id)
				.indexOf(element.id);

			if (itemIndex > -1) {
				this.scrollSections[section][itemIndex].visible = element.visible;
				this.changeVisibility.next(1);
			}
		}
	}

	/**
	 * Toggle the visible attr of an item in a section of the scrollSections object
	 * @param section 
	 * @param element 
	 */
	renderElement(section: string, element: ScrollableItemModel): void {
		if (section in this.scrollSections) {
			const itemIndex = this.scrollSections[section]
				.map((itm) => itm.id)
				.indexOf(element.id);
				
			if (itemIndex > -1) {
				this.scrollSections[section][itemIndex].rendered = true;
				// Timeout for AJSF
				// setTimeout(() => {
				this.changeRendered.next(this.scrollSections[section][itemIndex]);	
				// });
				
			}
		}
	}

	/**
	 * Reset all section of a scrollable
	 */
	resetSections(): void {
		this.scrollSections = {};
		this.disposableSections = {};
	}
}
